module.exports = __webpack_public_path__ + "assets/img/buy_word_course1.3515fca1.png";